import { ReactNode } from "react";

import {
  IconDownloadCloud01,
  IconFile06,
  IconPdf,
  IconXCircle,
} from "@pentabd/icons";
import { Button, FileInfoCard } from "@pentabd/ui";

import { InputDateControllerRow } from "./InputDateControllerRow";
import { InputTextRow } from "./InputTextRow";
import { TextRow } from "./TextRow";

import { useLanguage } from "@hooks/useLanguage";

import { downloadFile, getFilePreviewURL } from "@helpers/getFilePreviewURL";
import { UploadFileType } from "@type/HRM/upload-file";

interface FileType {
  id: string | number;
  downloadButton?: ReactNode;
  isSingle?: boolean;
  [key: string]: any;
}

export const CustomFileInfoCardUnique = ({
  id,
  fileName,
  fileType,
  documentId,
  fileId,
  setValue,
  fileArray,
  disabled,
  downloadButton,
  // customRow,
  register,
  deleteAction,
  itemId,
  control,
  fileDetails,
  isSingle,
  syncFile,
  syncMultiFile,
  updateSyncFile,
  selectedFile,
  viewOnly,
  doc,
  largeCol,
}: FileType) => {
  const { language } = useLanguage();

  const extension = fileName?.split(".").pop().toLowerCase();
  let startIcon;

  if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) {
    startIcon = (
      <div
        style={{ height: "40px", width: "40px" }}
        className="rounded-circle border overflow-hidden"
      >
        <img
          alt={fileName}
          src={`${getFilePreviewURL(documentId, fileId)}`}
          style={{ height: "100%", width: "100%", objectFit: "cover" }}
        />
      </div>
    );
    // } else if (extension === "txt") {
    //   startIcon = <IconFile05 size={40} fill="none" />;
  } else if (extension === "pdf") {
    startIcon = <IconPdf size={40} fill="none" />;
  } else if (["doc", "docx"].includes(extension)) {
    startIcon = <IconFile06 size={40} fill="subtitle2" />;
    // } else if (["xls", "xlsx"].includes(extension)) {
    //   startIcon = <IconExcel size={40} fill="none" />;
  } else {
    startIcon = <></>;
  }

  const deleteHandler = () => {
    deleteAction && deleteAction(itemId);
    if (fileArray) {
      const updatedFiles = [...fileArray];
      const updatedFilesWithoutItem = updatedFiles.filter(
        (item) => item.documentId !== documentId,
      );
      setValue(id, updatedFilesWithoutItem);
    } else {
      setValue(id, null);
    }
  };

  return (
    <FileInfoCard
      // key={id}
      title={fileName}
      subtitle={fileType}
      startIcon={startIcon}
      endIcon={
        <div className="d-flex  gap-8">
          {disabled ? (
            <a href={downloadFile(documentId, fileId)}>
              {downloadButton ? (
                downloadButton
              ) : (
                <IconDownloadCloud01 fill="info" size={16} />
              )}
            </a>
          ) : (
            <div className="d-flex gap-8">
              <a href={downloadFile(documentId, fileId)}>
                {downloadButton ? (
                  downloadButton
                ) : (
                  <IconDownloadCloud01 fill="info" size={16} />
                )}
              </a>
              <span className="pointer" onClick={deleteHandler}>
                <IconXCircle fill="danger" size={16} />
              </span>
            </div>
          )}
        </div>
      }
      customRow={
        fileDetails ? (
          <div>
            {fileDetails.includes("documentName") && (
              <InputTextRow
                size="xs"
                register={{
                  ...register(`documentName-${documentId}`),
                }}
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.DOCUMENT_NAME"
                controlling
                disabled={disabled}
              />
            )}
            {fileDetails.includes("date") && (
              <InputDateControllerRow
                size="xs"
                control={control}
                name={`date-${documentId}`}
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.DATE"
                disabled={disabled}
              />
            )}
            {fileDetails.includes("remarks") && (
              <InputTextRow
                size="xs"
                register={{
                  ...register(`remarks-${documentId}`),
                }}
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.REMARKS"
                controlling
                disabled={disabled}
              />
            )}
            {fileDetails.includes("memorialNo") && (
              <InputTextRow
                size="xs"
                register={{
                  ...register(`memorialNo-${documentId}`),
                }}
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.MEMORIAL_NO"
                controlling
                disabled={disabled}
              />
            )}
            {(syncFile || syncMultiFile) && !disabled && (
              <div className="d-flex justify-content-end">
                <Button
                  fill="outline"
                  type="info"
                  size="xs"
                  onClick={() =>
                    updateSyncFile(
                      (syncFile && selectedFile) ||
                        (syncMultiFile &&
                          selectedFile.find(
                            (item: UploadFileType) =>
                              item.documentId === documentId,
                          )),
                    )
                  }
                >
                  {language === "bn" ? "হালনাগাদ করুন" : "Update"}
                </Button>
              </div>
            )}
          </div>
        ) : viewOnly ? (
          <div>
            {doc?.documentName && (
              <TextRow
                largeCol={largeCol}
                size="sm"
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.DOCUMENT_NAME"
                value={doc?.documentName}
              />
            )}
            {doc?.date && (
              <TextRow
                largeCol={largeCol}
                size="sm"
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.DATE"
                value={doc?.date}
              />
            )}
            {doc?.remarks && (
              <TextRow
                largeCol={largeCol}
                size="sm"
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.REMARKS"
                value={doc?.remarks}
              />
            )}
            {doc?.memorialNo && (
              <TextRow
                largeCol={largeCol}
                size="sm"
                label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.MEMORIAL_NO"
                value={doc?.memorialNo}
              />
            )}
          </div>
        ) : (
          <></>
        )
      }
    />
  );
};
